import React, { useEffect, useRef, useState } from "react";
import "./css/IpoRights.css";
import { useRefreshContext } from "../context/RefreshContext";
import {
    deleteContractNote,
    fetchManualContractNoteNo,
    saveContractNote
} from "@portfolio/utils/PFService";

const IpoRights = ({ symbol: initialSymbol, onClose, onSave, isDisplayClick, contractNoteDTO,clientId }) => {
    const [transactionCategory, setTransactionCategory] = useState(""); // IPO or RIGHTS dropdown
    const [date, setDate] = useState(new Date().toISOString().split("T")[0]);
    const [quantity, setQuantity] = useState("");
    const [price, setPrice] = useState("");
    const [amount, setAmount] = useState("");
    const [narration, setNarration] = useState("");
    const [symbol, setSymbol] = useState(initialSymbol);
    const formRef = useRef(null);
    const { refreshPFdata } = useRefreshContext();

    useEffect(() => {
        if (isDisplayClick && contractNoteDTO?.transactions?.length > 0) {
            const txn = contractNoteDTO.transactions[0];
            setTransactionCategory(contractNoteDTO.contractNote.cnoteType); // IPO or RIGHTS
            setQuantity(txn.quantity);
            setPrice(txn.weightedAvgPrice);
            setAmount(txn.totalValue);
            setNarration(txn.narration);
            setDate(txn.tradeDate);
            setSymbol(txn.symbol);
        }
    }, []);

    const handleSave = async () => {
        if (!transactionCategory) {
            alert("Please select IPO or RIGHTS.");
            return;
        }

        if (!symbol || symbol.trim() === "") {
            alert("Please enter a valid script name.");
            return;
        }

        if (!quantity || isNaN(quantity) || quantity <= 0) {
            alert("Please enter a valid quantity.");
            return;
        }

        let manualNote = contractNoteDTO?.contractNote?.contractNoteNo || "";
        if (!isDisplayClick) {
            manualNote = await fetchManualContractNoteNo(`${transactionCategory}-CNT-`);
        }

        const parsedQuantity = parseInt(quantity, 10);
        const parsedPrice = parseFloat(price);
        const parsedAmount = parseFloat(amount);

        const newContractNote = {
            contractNote: {
                contractNoteNo: manualNote,
                clientId: clientId,
                brokerName: "",
                tradeDate: date,
                cnoteType: transactionCategory,
            },
            cnotesCharge: {
                contractNoteNo: "",
                securitiesTransactionTaxEquity: "",
                stampDutyEquity: "",
                igstEquity: "",
                exchangeTransactionChargesEquity: "",
                otherCharges: "",
                netAmountNetTotal: 0.0,
            },
            transactions: [
                {
                    type: "IpoRightsTransactionDTO",
                    contractNoteNo: manualNote,
                    clientId: clientId,
                    symbol: symbol,
                    transactionType: transactionCategory,
                    quantity: parsedQuantity,
                    weightedAvgPrice: parsedPrice,
                    totalValue: parsedAmount,
                    tradeDate: date,
                    narration: narration ?? ""
                }
            ],
            cnoteType: transactionCategory
        };

        try {
            const result = await saveContractNote(newContractNote, isDisplayClick);
            if (result.success) {
                refreshPFdata();
                onSave(newContractNote);
                onClose();
            }
        } catch (error) {
            console.error("Error saving IPO/Rights:", error);
        }
    };

    const handleDelete = async () => {
        try {
            const result = await deleteContractNote(contractNoteDTO.contractNote.contractNoteNo);
            if (result.success) {
                refreshPFdata();
                onClose();
            }
        } catch (error) {
            console.error("Error deleting IPO/Rights:", error);
        }
    };

    return (
        <div className="popup-overlay merger-overlay">
            <form ref={formRef}>
                <div className="merger-popup" onClick={(e) => e.stopPropagation()}>
                    <div className="header-row">
                        <h3>IPO / Rights</h3>
                        <h3>{clientId}</h3>
                    </div>

                    <div className="form-group">
                        <label className="general-label">Type:</label>
                        {isDisplayClick ? (
                            <input type="text" value={transactionCategory} disabled/>
                        ) : (
                            <select
                                value={transactionCategory}
                                onChange={(e) => setTransactionCategory(e.target.value)}
                            >
                                <option value="">Select</option>
                                <option value="IPO">IPO</option>
                                <option value="RIGHTS">RIGHTS</option>
                            </select>
                        )}
                    </div>

                    <div className="form-group">
                        <label className="general-label">ClientId:</label>
                        <input
                            type="text"
                            value={clientId}
                            onChange={(e) => setSymbol(e.target.value)}
                            disabled
                        />
                    </div>

                    <div className="form-group">
                        <label className="general-label">Script:</label>
                        <input
                            type="text"
                            value={symbol}
                            onChange={(e) => setSymbol(e.target.value)}
                            /*disabled={isDisplayClick}*/
                        />
                    </div>

                    <h5>Transaction:</h5>

                    <div className="form-group">
                        <label className="general-label">Date:</label>
                        <input name="date" type="date" value={date} onChange={(e) => setDate(e.target.value)}/>
                    </div>

                    <div className="form-group">
                        <label className="general-label">Quantity:</label>
                        <input
                            type="number"
                            value={quantity}
                            onChange={(e) => setQuantity(e.target.value)}
                            min="1"
                        />
                    </div>

                    <div className="form-group">
                        <label className="general-label">Price:</label>
                        <input
                            type="number"
                            value={price}
                            onChange={(e) => setPrice(e.target.value)}
                            step="0.01"
                            min="0"
                        />
                    </div>

                    <div className="form-group">
                        <label className="general-label">Amount:</label>
                        <input
                            type="number"
                            value={amount}
                            onChange={(e) => setAmount(e.target.value)}
                            step="0.01"
                            min="0"
                        />
                    </div>

                    <div className="form-group">
                        <label className="general-label">Narration:</label>
                        <textarea
                            value={narration}
                            onChange={(e) => setNarration(e.target.value)}
                            rows="3"
                        />
                    </div>

                    <div className="contract-buttons">
                        {isDisplayClick && (
                            <button type="button" className="delete-button" onClick={handleDelete}>
                                Delete CNote
                            </button>
                        )}
                        <div className="right-buttons">
                            <button type="button" className="save-button" onClick={handleSave}>Save</button>
                            <button type="button" className="cancel-button" onClick={onClose}>Cancel</button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default IpoRights;
